// extracted by mini-css-extract-plugin
module.exports = {"light":"#fff","dark":"#1e1e1e","clown_rose":"#e94459"};